export { default as styledInputLabel } from 'styled-components'
